import App from './App'
import { bootstrapApp } from './bootstrap'
import '@fontsource-variable/archivo'
import '@fontsource-variable/instrument-sans'
import './globals.css'

bootstrapApp(App)
